
export class XmlDecodingException extends Error
{
    static requiredChildNotFound(elem: Element, tagName: string): XmlDecodingException
    {
        return new this(`Could not find required child element <${tagName}> in <${elem.tagName}>`);
    }

    static noRequiredChildFound(elem: Element, searchedChild: string[]): XmlDecodingException
    {
        return new this(`Element <${elem.tagName}> must have at least one of the following children: ${searchedChild.join(', ')}`);
    }

    static elementNotFoundInside(elem: Element, tagName: string): XmlDecodingException
    {
        return new this(`Could not find required element <${tagName}> inside <${elem.tagName}>`);
    }

    static emptyElement(elem: Element): XmlDecodingException
    {
        return new this(`Element <${elem.tagName}> cannot be empty`);
    }

    static attributeNotFound(elem: Element, attrName: string): XmlDecodingException
    {
        return new this(`Could not find required attribute "${attrName}" in element <${elem.tagName}>`);
    }

    static nullAttribute(elem: Element, attrName: string): XmlDecodingException
    {
        return new this(`Attribute "${attrName}" on element <${elem.tagName}> must have a value`);
    }

    static notInEnum<T>(elem: Element, sourceEnum: T): XmlDecodingException
    {
        return new this(`Value "${elem.textContent}" is not part of enum containing "${Object.values(sourceEnum).join(", ")}"`);
    }

    static invalidDate(elem: Element, badValue: string): XmlDecodingException
    {
        return new this(`Element <${elem.tagName}> contains an unparseable date: "${badValue}"`);
    }

    static invalidNumber(elem: Element, badValue: string): XmlDecodingException
    {
        return new this(`Element <${elem.tagName}> contains an unparseable number: "${badValue}"`);
    }
}
